/**
 * Availability Page
 * Weekly schedule and absence management for examiners.
 * Accessible to gutachter, assistent, and administrator roles.
 */
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AvailabilityPanel } from "@/components/scheduling/availability/AvailabilityPanel";

export const Route = createFileRoute("/_authenticated/availability/")({
  component: AvailabilityPage,
});

function AvailabilityPage() {
  const { t } = useTranslation("availability");
  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div>
        <h1 className="text-2xl font-bold tracking-tight">{t("title")}</h1>
        <p className="text-muted-foreground">
          {t("subtitle")}
        </p>
      </div>

      <AvailabilityPanel />
    </div>
  );
}
